export enum QuizCategory {
    ALL = "ALL",
    SER_VS_ESTAR = "SER_VS_ESTAR",
    POR_VS_PARA = "POR_VS_PARA",
    PRESENT = "PRESENT",
    PAST_TENSE = "PAST_TENSE",
    FUTURE_TENSE = "FUTURE_TENSE",
    CONDITIONAL = "CONDITIONAL",
    SUBJUNCTIVE = "SUBJUNCTIVE",
    PREPOSITIONS = "PREPOSITIONS",
    IDIOMATIC_EXPRESSIONS = "IDIOMATIC_EXPRESSIONS",
    DISCOURSE_CONNECTORS = "DISCOURSE_CONNECTORS",
    IMPERATIVE = "IMPERATIVE",
    PRONOUNS = "PRONOUNS",
    VERBOS_REFLEXIVOS = "VERBOS_REFLEXIVOS",
    VOZ_ACTIVA_PASIVA = "VOZ_ACTIVA_PASIVA",
    PRONUNCIATION = "PRONUNCIATION",
}

export const quizCategoryExplanation = "Select the categories you want to practice. A quiz will be formed including each selected category.";
